import { Box, Typography, useTheme } from "@mui/material";

type ChipAvailableProps = {
  available: number;
};
export const ChipAvailable = ({ available }: ChipAvailableProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        textAlign: "center",
        padding: "5px 8px",
        borderRadius: 1,
        transition: "background 0.8s ease",
        backgroundColor: available > 0
          ? theme.palette.success[200]
          : theme.palette.warning.main,
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: 13,
          color: available > 0
            ? theme.palette.success[900]
            : theme.palette.common.white,
        }}
      >
        {`Available ${available}`}
      </Typography>
    </Box>
  );
};
